import { Injectable } from "@angular/core";
import { ReadyForDeliveryToastDisplay } from "@shared/db/db-domain.model";
import { db } from "@shared/db/db.repository";
import { DbService } from "@shared/db/db.service";

const toastDisplayIntervalDays = 1;

@Injectable({
    providedIn: 'root',
})
export class ReadyForDeliveryToastDisplayService extends DbService<ReadyForDeliveryToastDisplay> {
    constructor() {
        super(db.readyForDeliveryToastDisplays, toastDisplayIntervalDays);
    }

    async hasBeenShown(projectId: string): Promise<boolean> {
        return !!(await this.table.get(projectId));
    }

    async markShown(projectId: string): Promise<void> {
        await this.table.put({ id: projectId, projectId, created: new Date() });
    }
}
